




























































import Vue from "vue";

import iconClose from "@joyz/app-core/assets/icons/black/Close.svg";
import iconLevel from "@joyz/app-core/assets/icons/default/Level.svg";
import iconRadio from "@joyz/app-core/assets/icons/misc/TT4WRadio.svg";
import iconRadioSelected from "@joyz/app-core/assets/icons/misc/TT4WRadioChecked.svg";
import SkillCompletionGraph from "@tt-app/components/skills/SkillCompletionGraph.vue";

interface Data {
  icons: {
    [iconName: string]:
      | string
      | {
          [iconName: string]: string;
        };
  };
  selectedIndex: number | null;
}

interface Methods {
  completionPercent: (learned: number, possible: number) => number;
  levelSelectionHandler: (index: number) => void;
}

interface Computed {
  nextButtonDisabled: boolean;
}

interface Props {
  levels: {
    learned: number;
    possible: number;
    title: string;
  }[];
  open: boolean;
  selectedLevelIndex: number;
  type: number;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "SkillLevelSelectModal",
  components: {
    SkillCompletionGraph
  },
  props: {
    levels: {
      type: Array,
      default: () => []
    },
    open: {
      type: Boolean,
      default: false
    },
    selectedLevelIndex: {
      type: Number,
      default: undefined
    },
    type: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      icons: {
        close: iconClose,
        level: iconLevel,
        radio: {
          default: iconRadio,
          selected: iconRadioSelected
        }
      },
      selectedIndex: this.selectedLevelIndex
    };
  },
  computed: {
    nextButtonDisabled() {
      if (this.selectedIndex === null) return true;

      return !(this.selectedIndex >= 0);
    }
  },
  methods: {
    completionPercent(learned: number, possible: number) {
      if (!learned || !possible) return 0;

      return Math.floor((learned / possible) * 100);
    },
    levelSelectionHandler(index) {
      this.selectedIndex = index;

      if (this.selectedIndex) {
        return this.selectedIndex;
      }

      return this.selectedLevelIndex;
    }
  }
});
